export enum MppConfirmationType {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  ACCENT = 'accent',
}
